<template>
    <v-container class="pa-0" fluid>
        <v-layout row wrap>
            <v-flex xs12>
                <starter-template-dialog
                        :disabled="loading"
                        :event_id="event.id"
                        :value.sync="dialog"
                        @submit="loadStarterTemplates"
                ></starter-template-dialog>
            </v-flex>

            <v-flex xs12>
                <h3>Bitte alle Starter auswählen, die Du zum Turnier anmelden möchtest.</h3>
                <starter-template-list
                        selectable
                        :items="possibleStarterTemplates"
                        :selected.sync="selectedStarterTemplates"
                        :loading="loading" :rules="event.event_rule.name"
                ></starter-template-list>

                <v-btn class="right mx-0 pl-2 pr-2" :loading="loading" :disabled="loading || selectedStarterTemplates.length === 0" color="primary" @click.native="submit" v-t="'continue'"></v-btn>
                <v-btn class="right" :disabled="loading" flat @click.native="$emit('back')" v-t="'back'"></v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    import ItemList from '../../../components/common/ItemList';
    import StarterTemplateDialog from "../../dialogs/StarterTemplateDialog";
    import StarterTemplateList from '../../user/StarterTemplateList';

    export default {
        components: {
            ItemList,
            StarterTemplateDialog,
            StarterTemplateList
        },
        props: {
            event: {
                type: Object,
                default: {}
            },
            isDirty: {
                type: Boolean,
                default: true
            },
            value: {
                type: Array,
                default: null
            }
        },
        data () {
            return {
                loading: false,
                dialog: false,
                starters: [],
                possibleStarterTemplates: [],
                selectedStarterTemplates: [],
                dataTableConfig: {
                    loadingDataText: 'Keine Starter ausgewählt',
                    noDataText: 'Keine Starter verfügbar',
                    rowsPerPageText: 'Zeilen pro Seite',
                    headers: [
                        {text: 'Starter', value: 'name', align: 'left'},
                        {text: 'Anzahl', value: 'dancer_count', align: 'left'}
                    ],
                    items: {
                        large: [
                            {value: 'name'},
                            {value: 'dancer_count'}
                        ],
                        small: [
                            {value: 'name'},
                            {value: 'dancer_count'}
                        ]
                    }
                }
            }
        },
        computed: {
            isSelectionChanged() {
                return !_.every(this.selectedStarterTemplates, s => _.some(this.starters, st => st.member_hash === s.member_hash));
            },
            ...mapState(['starterTemplates'])
        },
        watch: {
            starters() {
                this.$emit('update:value', this.starters);
            },
            selectedStarterTemplates() {
                this.$emit('update:isDirty', this.isSelectionChanged);
            }
        },
        mounted() {
            this.starters = _.cloneDeep(this.value);

            this.loadStarterTemplates();
        },
        methods: {
            loadStarterTemplates() {
                this.loading = true;
                axios.get(`/api/v1/event_registrations/starter_templates/${this.event.id}`).then(response => {
                    if (!response.data.success) {
                        this.loading = false;
                        return;
                    }

                    this.$set(this, 'possibleStarterTemplates', response.data.data);

                    if (this.selectedStarterTemplates.length === 0) {
                        this.selectedStarterTemplates = _.filter(this.possibleStarterTemplates, s => _.some(this.starters, st => st.member_hash === s.member_hash));
                    }

                    this.loading = false;
                }, errorResponse => {
                });
            },
            submit() {
                if (!this.isSelectionChanged) {
                    this.$emit('forward');
                    return;
                }

                this.loading = true;

                let createRequests = [];
                _.each(this.selectedStarterTemplates, st => {
                    let contains = _.some(this.starters, s => s.member_hash === st.member_hash);
                    if (!contains) {
                        createRequests.push(this.createStarter(st));
                    }
                });

                axios.all(createRequests)
                    .then(axios.spread((...starters) => {
                        // all requests are now complete

                        _.each(starters, s => {
                            this.starters.push(s.data.data);
                        });

                        let deleteRequests = [];
                        let startersToRemove = [];
                        _.each(this.starters, st => {
                            let contains = _.some(this.selectedStarterTemplates, s => s.member_hash === st.member_hash);
                            if (!contains) {
                                deleteRequests.push(this.deleteStarter(st));
                                startersToRemove.push(st);
                            }
                        });

                        axios.all(deleteRequests)
                            .then(axios.spread((...starters) => {

                                _.each(startersToRemove, s => {
                                    this.removeStarter(s);
                                });

                                this.loading = false;

                                this.$emit('forward');
                            }));
                    }));
            },
            createStarter(starterTemplate) {
                let dancerIds = [];
                _.each(starterTemplate.dancers, d => { dancerIds.push(d.id); });

                return axios.post('/api/v1/starters', {
                    event_id: this.event.id,
                    name: starterTemplate.name,
                    dancers: dancerIds
                });
            },
            deleteStarter(starter) {
                return axios.delete(`/api/v1/starters/${starter.id}`);
            },
            removeStarter(starter) {
                let index = -1;
                this.starters.forEach((item, _id) => {
                    if (starter.id === item.id) {
                        index = _id;
                        return false;
                    }
                });

                if (index > -1) {
                    this.starters.splice(index, 1);
                }
            },
            ...mapMutations(['snackBar'])
        }
    }
</script>